import PATH from "constants/path";
import React from "react";
import { Route, Switch } from "react-router-dom";
import AreaList from "./pages/Place";
import AreaDetail from "./pages/PlaceDetail";
import PageNotFound from "views/PageNotFound";

function Area() {
  return (
    <Switch>
      <Route exact path={PATH.AREA_LIST} component={AreaList} />
      <Route exact path={PATH.AREA_DETAIL} component={AreaDetail} />
      <Route component={PageNotFound} />
    </Switch>
  );
}

export default Area;
